import { useUserStore } from '../../stores/user.js';

const dashboardRoles = ['Super Admin', 'Market and Regional Lead Permissions'];

const verifyDashboardAccess = () => {
  const userStore = useUserStore();
  if (dashboardRoles.includes(userStore.currentUser?.role)) {
    return true;
  }
  return { path: '/schools' };
};

export default [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/dashboard/index.vue'),
    beforeEnter: verifyDashboardAccess,
  },
];
